// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2qTvo","label":"Completed_label__2gbk5"};